

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../../layouts";
import { UsersSetup } from "../../../components/RoleManagement/UsersSetup";


export const UsersSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Users Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Users", navigateTo: "/role-management/users" }
      ]}
      mainContents={<UsersSetup />}
    />
  );
};
